/* eslint-disable prefer-const */
/* eslint-disable no-restricted-syntax */
import { window } from "ssr-window";
import { useState, useEffect } from "react";

export function shallowEqual(object1, object2) {
	if (!object1 || !object2) {
		return false;
	}

	const keys1 = Object.keys(object1 || {});
	const keys2 = Object.keys(object2 || {});

	if (keys1.length !== keys2.length) {
		return false;
	}

	for (let key of keys1) {
		if (object1[key] !== object2[key]) {
			return false;
		}
	}

	return true;
}

export default (defaultValue, key) => {
	const localStorage = window?.localStorage;

	const [value, setValue] = useState(() => {
		const stickyValue = localStorage
			? localStorage.getItem(key)
			: defaultValue;
		return stickyValue !== undefined &&
			stickyValue !== "undefined" &&
			stickyValue !== null &&
			stickyValue !== "null"
			? JSON.parse(stickyValue)
			: defaultValue;
	});

	useEffect(() => {
		if (localStorage && typeof localStorage.setItem === "function") {
			localStorage.setItem(key, JSON.stringify(value));
		}
	}, [defaultValue, key, value]);

	const hasChanges =
		typeof defaultValue === "object"
			? shallowEqual(defaultValue) !== shallowEqual(value)
			: defaultValue !== value;

	const restart = () => setValue(defaultValue);

	return [value, setValue, { hasChanges, restart }];
};
